<template>
    <PrimeButton :class="computedClass()">
        <i :class="icon" class="icon-style"/>
    </PrimeButton>
</template>

<script>
    import PrimeButton from "primevue/button";

    export default {
        name: "CustomIconButton",

        props: {
            icon: {
                type: String,
            },
            small: {
                type: Boolean,
                default: false,
            },
            onlyIcon: {
                type: Boolean,
                default: false,
            },
        },

        components: {
            PrimeButton,
        },

        data() {
            return {};
        },

        methods: {
            computedClass() {
                let classes = "custom-icon-button";
                if (this.small) classes += " small-icon-button";
                if (this.onlyIcon) classes += " only-icon";
                return classes;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/theme/mytheme/variables";
    .custom-icon-button {
        width: 50px;
        height: 50px;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: var(--primary-button-color);
        border: none;
        .icon-style {
            font-size: 30px;
            font-weight: 600;
        }
        &:hover {
            opacity: 0.8;
        }
    }
    .small-icon-button {
        width: 25px;
        height: 25px;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        background-color: var(--primary-button-color);
        .icon-style {
            font-size: 10px;
        }
    }
    .only-icon {
        background: none;
        width: 1rem;
        height: 1rem;
        .icon-style {
            color: var(--primary-button-color);
            font-size: 1rem;
        }
        &.p-button:enabled:hover {
            background: none;
        }
    }
</style>
